:root ._dsp-flex{display:flex;}
:root ._fd-column{flex-direction:column;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._items-center{align-items:center;}
:root ._width-t-size-medi3736{width:var(--t-size-medium);}
:root ._shrink-1{flex-shrink:1;}
:root ._items-flex-start{align-items:flex-start;}
:root ._gap-t-space-med104641{gap:var(--t-space-medium);}
:root ._grow-1{flex-grow:1;}
:root ._items-stretch{align-items:stretch;}